import React from 'react'
import { Input } from 'loyal-react'
import PropTypes from 'prop-types'

const Address = ({
  address,
  errors,
  disabled,
  updateState,
  handleZipCode
}) => {
  return (
    <div className='row'>
      <div className='col-sm-6 mt-2'>
        <Input
          id='zipCode'
          label='CEP'
          value={address.zipCode}
          mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
          aria-required
          data-error='Digite um CEP válido'
          valid={errors.zipCode}
          disabled={disabled.zipCode}
          onBlur={handleZipCode}
          onChange={(e) => updateState('zipCode', e.target.value, false, true)}
        />
      </div>
      <div className='col-sm-6 mt-2'>
        <Input
          id='address'
          label='Logradouro'
          value={address.street}
          aria-required
          data-error='Digite um Endereço válido'
          valid={errors.street}
          disabled={disabled.street}
          onChange={(e) => updateState('street', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='number'
          label='Número'
          value={address.number}
          aria-required
          data-error='Digite o seu número ou 0 para sem número'
          valid={errors.number}
          disabled={disabled.number}
          onChange={(e) => updateState('number', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='complement'
          label='Complemento'
          value={address.complement}
          aria-required
          data-error='Digite no mínimo 4 caracteres, ex: apto 01 - bloco A'
          valid={errors.complement}
          disabled={disabled.complement}
          onChange={(e) => updateState('complement', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='reference'
          label='Ponto de Referência'
          value={address.reference}
          aria-required
          data-error='Digite no mínimo 4 caracteres.'
          valid={errors.reference}
          disabled={disabled.reference}
          onChange={(e) => updateState('reference', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='District'
          label='Bairro'
          value={address.district}
          aria-required
          data-error='Digite um Bairro válido'
          valid={errors.district}
          disabled={disabled.district}
          onChange={(e) => updateState('district', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='city'
          label='Cidade'
          value={address.city}
          aria-required
          data-error='Digite uma Cidade válida'
          valid={errors.city}
          disabled={disabled.city}
          onChange={(e) => updateState('city', e.target.value, false, true)}
        />
      </div>
      <div className='col-md-4 col-sm-6 mt-2'>
        <Input
          id='state'
          label='Estado'
          value={address.state}
          aria-required
          data-error='Digite um Estado Válido'
          valid={errors.state}
          disabled={disabled.state}
          onChange={(e) => updateState('state', e.target.value, false, true)}
        />
      </div>
    </div>
  )
}

Address.propTypes = {
  address: PropTypes.object,
  errors: PropTypes.object,
  disabled: PropTypes.object,
  handleZipCode: PropTypes.func,
  updateState: PropTypes.func
}

export default Address



// WEBPACK FOOTER //
// ./src/features/UserInfosValidation/Address.js